import { Component } from '@angular/core';

@Component({
  selector: 'app-booking-tecketing',
  templateUrl: './booking-tecketing.component.html',
  styleUrls: ['./booking-tecketing.component.css']
})
export class BookingTecketingComponent {
english:boolean=true;
hindi:boolean=false;
ngOnInit(): void {
  const storeVal = localStorage.getItem('selectedValue');
  if (storeVal == 'english') {
    this.english = true;
    this.hindi = false;
  }
  if (storeVal == 'hindi') {

    this.english = false;
    this.hindi = true;
  }

}
}
